import { FC } from 'react'

import { useParams } from '@tanstack/react-router'

import { Cluster, Skeleton, Stack, Table } from '@forto-dev/phoenix-ui-core'

import { WidgetSkeleton } from '@/fragments/widgetSkeleton'
import { useLocalisation } from '@/utils/localisation/useLocalisation'

import { BookingOverviewTabLayout } from '../components/BookingLayout'
import { BookingDetailsTitleSkeleton } from '../components/details/BookingDetailsSkeleton'

export const DocumentsSkeleton: FC = () => {
  const { id } = useParams({
    from: '/bookings/$id/documents',
  })
  const { translate } = useLocalisation()
  return (
    <BookingOverviewTabLayout
      sidebar={<WidgetSkeleton count={1} />}
      title={<BookingDetailsTitleSkeleton />}
      main={
        <Stack gap={24}>
          <Skeleton variant="content" size={16} fullWidth />
          <Cluster gap={8} y="center">
            <Skeleton variant="badge" />
            <Skeleton variant="badge" />
          </Cluster>
          <Table
            columns={[
              {
                accessorKey: 'name',
                header: translate('documents.table.name'),
                cell: () => <Skeleton variant="content" />,
              },
              {
                accessorKey: 'version',
                header: translate('documents.table.version'),
                cell: () => <Skeleton variant="content" />,
              },
              {
                accessorKey: 'date',
                header: translate('documents.table.date'),
                cell: () => <Skeleton variant="content" />,
              },
              {
                accessorKey: 'uploaded',
                header: translate('documents.table.uploaded'),
                cell: () => <Skeleton variant="content" />,
              },
              {
                accessorKey: 'actions',
                header: '',
                cell: () => (
                  <Cluster gap={8} fullWidth x="end">
                    <Skeleton variant="icon" />
                    <Skeleton variant="icon" />
                    <Skeleton variant="icon" />
                    <Skeleton variant="icon" />
                  </Cluster>
                ),
              },
            ]}
            data={[{}]}
            footless
          />
        </Stack>
      }
      bookingId={id}
    />
  )
}
